import Alert from './Alert'
export default class SuccessfullyUpdatedAlert extends Alert{
    show() {
        return swal({
            title: this.key('title', uLang('app.success')),
            text: uLang('app.entity_updated', {entity: this.key('entity')}),
            icon: "success",
            button: this.key('button', uLang('app.close')),
            closeOnClickOutside: false,
            closeOnEsc: false,
        })
    }
}
